import {Button, Popover, Space} from 'antd';
import React, {useState} from 'react';
import {Translate} from "../util/translation.util";
import {TranslationDomainEnum} from "../../types/enums";

export const ConfirmButton: React.FC<{ message: string, domain?: TranslationDomainEnum, onClick: () => void }> = ({ message, domain, onClick }) => {
    const [open, setOpen] = useState(false);

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };

    return (
        <Popover
            content={
                <React.Fragment>
                    <Space>
                        <Button size={`small`} danger type={`primary`} onClick={ () => {
                            handleOpenChange(false);
                            onClick();
                        } }><Translate message={`global.yes`} /></Button>
                        <Button size={`small`} onClick={() => {
                            handleOpenChange(false);
                        }}><Translate message={`global.no`} /></Button>
                    </Space>
                </React.Fragment>
            }
            title={<Translate message={message} domain={domain ?? TranslationDomainEnum.MESSAGES} />}
            trigger="click"
            open={open}
            onOpenChange={handleOpenChange}
        >
            <Button type="primary" className={`ant-btn-secondary`}>
                <Translate message={message} domain={domain ?? TranslationDomainEnum.MESSAGES} />
            </Button>
        </Popover>
    );
};
